
import { z } from "zod";

const ItemSchema = z.object({
  product_id: z.string().uuid("Product is required"),
  product_name: z.string().min(1, "Product name is required"),
  unit_of_measure: z.string().default('kg'),
  price_per_unit: z.number().min(0, "Price must be positive"),
  quantity: z.number().min(0.01, "Quantity must be greater than 0"),
  quality_grade: z.string().optional(),
  notes: z.string().optional(),
});

export const procurementFormSchema = z.object({
  source_type: z.enum(["farm", "supplier", "agent", "harvest"]),
  source_id: z.string().min(1, "Source is required"),
  items: z.array(ItemSchema).min(1, "At least one item is required"),
  expected_delivery_date: z.date().optional().nullable(),
  transport_cost_per_unit: z.number().min(0).default(0),
  loading_unloading_cost_per_unit: z.number().min(0).default(0),
  agent_cost_per_unit: z.number().min(0).default(0),
  other_cost_per_unit: z.number().min(0).default(0),
  other_cost_description: z.string().optional(),
  vat_applicable: z.boolean().default(false),
  payment_term_type: z.enum(["upfront", "term"]).default("upfront"),
  payment_term_days: z.number().min(0).default(0),
  payment_due_date: z.date().optional().nullable(),
  supports_damage_return: z.boolean().default(false),
  damage_return_percentage: z.number().min(0).max(100).default(0),
  has_advance_payment: z.boolean().default(false),
  advance_payment_amount: z.number().min(0).default(0),
  remaining_payment_amount: z.number().min(0).default(0),
  use_different_bank: z.boolean().default(false),
  bank_name: z.string().optional(),
  bank_account: z.string().optional(),
  bank_branch: z.string().optional(),
  account_holder_name: z.string().optional(),
  notes: z.string().optional(),
  total_amount: z.number().min(0).default(0),
}).refine((data) => {
  // If advance payment is enabled, validate that advance amount doesn't exceed total amount
  if (data.has_advance_payment && data.advance_payment_amount > data.total_amount) {
    return false;
  }
  return true;
}, {
  message: "Advance payment amount cannot exceed total amount",
  path: ["advance_payment_amount"],
});

export type ProcurementFormValues = z.infer<typeof procurementFormSchema>;
